// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> parc-at-west-point
// Generated: 2026-10-22T20:05:54.356Z
// Counts: 1 design, 68 content, 65 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1, 2, & 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1, 2, & 3 Bedroom Apartments for Rent in North Wales , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Parc at West Point, where community meets convenience in North Wales, PA. Enjoy spacious one, two, and three-bedroom apartments, all within reach of vibrant local attractions like parks, theaters, and schools. Discover your perfect home and embrace a lifestyle enriched by nearby gems. Explore your neighborhood today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace the Joy of Living in Your Dream Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Home should be more than just a place to lay your head. Parc at West Point gives you the opportunity to relax, socialize, and make memories. Imagine living in our pet-friendly one, two, and three bedroom apartments with cushy interiors that feature private balconies and private entrances. You’ll have access to perks like a playground and grilling and picnic area to help your day be a bit brighter.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy exceptional amenities like a pet-friendly dog park, sparkling swimming pool, and state-of-the-art fitness center, all while relishing the convenience of online leasing. Your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, your dream home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored for your lifestyle. Curious about making one yours? Reach out to our leasing team today—we're here to help you find the perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, your dream home awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, each crafted to enhance your lifestyle. Browse our available apartment homes to find the perfect fit for your unique needs and embrace a vibrant community experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, your ideal home awaits! Choose from stylish floor plans, each featuring modern amenities like stainless steel appliances, vaulted ceilings, and private entrances. With a dog park, relaxing pool, and vibrant playground, picture your life thriving in this welcoming community today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything you need is at your fingertips in our corner of North Wales. Enjoy a choice of great parks in the area, including Parkside Place Park, plus a wide range of employment opportunities. Getting groceries and basics could not be easier with Whole Foods Market and other stores nearby, from big-box retailers to independent shops. Come by and see our community at Parc at West Point, and explore the neighborhood while you’re here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in North Wales , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">We’re a pet-friendly community and happily welcome cats and dogs. Up to two pets are permitted per apartment. Breed restrictions apply. Please contact the leasing office for details.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your perfect fit in a great location in North Wales with a one, two, or three bedroom apartment at Parc at West Point. This pet-friendly community features amenities designed to simplify your life and a friendly vibe that will make you feel welcome from day one. Our spacious floor plans have been thoughtfully upgraded for style and comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, our diverse floor plans cater to every lifestyle, whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven. Enhance your living experience by accessing the resident portal for effortless rent payments, maintenance scheduling, and so much more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at West Point in North Wales, PA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Experience a vibrant community where modern living meets convenience. Curious about our vibrant lifestyle? Hear directly from our residents and schedule your tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for your interest in Parc at West Point! Nestled in North Wales, PA, we offer spacious one, two, and three-bedroom floor plans designed for your comfort. Your journey to exceptional living starts now—stay tuned as our team reaches out to you shortly with all the details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the perfect blend of comfort and style at Parc at West Point in North Wales, PA. With thoughtfully designed one, two, and three-bedroom floor plans, our community caters to every lifestyle. Immerse yourself in our virtual tour and envision your future home today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e218-724f-964c-0c0d15d0579c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen in a modern apartment with white cabinets, stainless appliances, and a window."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-10dd-72ad-8f78-bbaaeaed6bb7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with cardio machines and mirrors."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-10dd-72ad-8f78-bbaaeaed6bb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines and mirrors."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166338/019d026b-3998-75ff-b0f6-b07315c9dbf9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with cable crossover machine, weight bench, and dumbbell rack."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166338/019d026b-5995-71dd-b99a-cc85ad973c2f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with elliptical machines and treadmills."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-e205-71d9-8059-508527da5f9a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a large bed, bench at foot, dresser, and window with white curtains."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-ecb9-74f2-8592-ef692a3f7fbd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, stainless steel fridge and appliances, and white marble backsplash."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce04-edcb-70ac-8176-d1a8fcfc73f9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a sectional sofa, plant, coffee table, and sliding glass door."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-2c3f-77b1-a43b-df234821a652.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick apartment community along a tree-lined street with a prominent sign in the foreground."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-a354-7479-bcbb-4f6a58d2dacf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Valley Forge National Historical Park, a Revolutionary War site with open green fields and wooded trails near North Wales."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9c0d-72ad-99a8-0c96c9939946.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooded walking trail at Natural Lands' Gwynedd Preserve, a peaceful nature spot near the community."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-48d8-7343-bf5e-8d7641cf5480.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Iron Hill Brewery & Restaurant, a nearby brewpub serving house-made beers and comfort food."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1351-735d-9f13-28ab7b6cfc12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community swimming pool with blue water, lounge chairs, and trees."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1351-735d-9f13-28ab7b6cfc12.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community swimming pool with blue water, lounge chairs, and trees."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1d2b-71b3-ae5d-6cf1242ac422.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden pavilion with picnic tables and grills at a residential community; playground visible in background."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-279a-719a-9173-d2534ea0be28.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced outdoor community park with a small playground, agility equipment, and a bench."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$250"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$175"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_situational": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "350"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant."
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "additional": {
        "type": "VALUE",
        "customValue": ""
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$14"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce6c-e245-74be-b652-0e6169e31fd1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View All"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0268-c86a-76c8-b2f5-b810e8cb5e05.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room with grey sofa, dining table, and sliding glass door to the patio."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce6c-e243-761a-8672-12723bebafa1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "One Bedroom"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce6c-e1e0-77b4-ab78-b7699fc0484b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two Bedroom"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce6c-e258-7766-a97f-eca1daddf0dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three Bedroom"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-4328-763f-a6a4-b1eed69d8a91.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Alice Bakery & Confectionary"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bakery & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Start the morning at this from-scratch neighborhood bakery, where fresh breads, pastries and cakes pair with coffee and a warm, friendly welcome."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5cb7-731a-b0bf-a853c18de4bf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Target"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A one-stop retail favorite for home goods, clothing, electronics and groceries, plus exclusive designer collections for an easy afternoon of shopping."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9c0d-72ad-99a8-0c96c9939946.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Natural Lands' Gwynedd Preserve"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Nature"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A peaceful 279-acre oasis of meadows, woodlands and wetlands with miles of easy trails, native wildflowers and abundant local wildlife right at your doorstep."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-43e6-7099-8866-38666717def0.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Turning Point of North Wales"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A stylish daytime spot for breakfast and brunch, serving fresh sandwiches, creative plates and tea and coffee drinks in bright, welcoming surroundings."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-7aa5-700b-9b63-2d9691069241.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Byers' Choice LTD."
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A one-of-a-kind Christmas-themed attraction showcasing handcrafted dolls and figurines in intricate traditional scenes, a charming afternoon of local artistry."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-9e04-7618-bc8c-dad76098919a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Norristown Farm Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lace up for more than 7 miles of paved trails ideal for biking and hiking, plus a stocked trout stream, in this expansive green space escape."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-48d8-7343-bf5e-8d7641cf5480.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Iron Hill Brewery & Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewpub & Bar"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A lively regional brewpub pouring house-made craft beers alongside elevated comfort food, a go-to for an easygoing evening out."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-800f-761e-9df4-f9e2debd3bc9.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Keswick Theatre"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A historic 1,300-seat theater built in 1928 as a vaudeville and movie house, now hosting a diverse lineup of live music and touring acts."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-49f8-741a-9859-5ec8d113fc13.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bonefish Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A contemporary grill for an evening out, with a seafood-forward menu plus steaks and hand-crafted cocktails in a polished setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-5544-7683-84b9-b905a76a032f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Pour House - North Wales"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "An easygoing late-night hangout for comfort food like burgers and flatbreads paired with a big beer list and a relaxed, social atmosphere."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-81db-74b8-a709-61b8a29ac3f1.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Flagship Cinemas Water Tower"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A neighborhood cinema showing the latest releases with comfortable stadium seating and rewards for frequent moviegoers, perfect for a night at the movies."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-50fb-7288-b2a5-5f68fa8949ae.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "OOKA Restaurant Bar . Sushi .Hibachi"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Sushi & Hibachi"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "An urbane, wood-accented spot serving sushi, teppanyaki and Japanese favorites, an inviting choice for a later evening dinner and drinks at the bar."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-9f6f-77e6-8ff2-cd2f4c94d32a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Valley Forge National Historical Park with open green fields and Revolutionary War-era landmarks."
      }
    }
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-9b76-704d-b3b8-4534632dc78e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooded trail at Fort Washington State Park near North Wales, PA."
      }
    }
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-9bdd-7566-918c-2786af16664a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Paved trail winding through the greenery of Norristown Farm Park."
      }
    }
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019d0269-9cc1-72bd-beff-28c6d617ca2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wildlife exhibit at nearby Elmwood Park Zoo."
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166338/019fce05-1351-735d-9f13-28ab7b6cfc12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community swimming pool with blue water, lounge chairs, and trees."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
